module.exports = __webpack_public_path__ + "static/media/Tick.21d3760e.jpg";